<template>
  <div class="auth-panel">
    <template v-if="updated">
      <h1 class="card-title">Password updated</h1>
      <p class="card-hint" role="status">
        Your password has been updated. Taking you to sign in in {{ countdown }}s.
      </p>
      <p class="card-links">
        <router-link class="card-link" :to="{ name: 'Login' }">Go to sign in now</router-link>
      </p>
    </template>
    <template v-else>
      <h1 class="card-title">Update password</h1>
      <p class="card-hint">Choose a new password for your account.</p>
      <UpdatePasswordForm @onSuccess="onSuccess" @onFailure="onFailure" />
      <p class="card-links">
        <router-link v-if="failed" class="card-link" :to="{ name: 'ForgotPassword' }">
          Request a new link
        </router-link>
        <router-link v-else class="card-link" :to="{ name: 'Login' }">Back to sign in</router-link>
      </p>
    </template>
  </div>
</template>

<script>
import UpdatePasswordForm from '@/components/auth/UpdatePasswordForm';

const REDIRECT_SECONDS = 5;

export default {
  name: 'UpdatePassword',
  components: {
    UpdatePasswordForm,
  },
  inject: {
    authStage: { default: null },
  },
  data() {
    return {
      updated: false,
      failed: false,
      countdown: REDIRECT_SECONDS,
    };
  },
  created() {
    this.countdownTimer = null;
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    onSuccess() {
      this.updated = true;
      this.failed = false;
      this.countdown = REDIRECT_SECONDS;
      this.countdownTimer = setInterval(this.tick, 1000);
    },
    tick() {
      this.countdown -= 1;
      if (this.countdown > 0) return;
      this.stopCountdown();
      this.$router.push({ name: 'Login' });
    },
    stopCountdown() {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    },
    onFailure() {
      this.failed = true;
      if (this.authStage) this.authStage.pulse('error');
    },
  },
};
</script>
